import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative expanded"
}
const _hoisted_2 = { class: "w-full mx-auto pt-2" }
const _hoisted_3 = {
  key: 1,
  class: "w-full flex pb-4 pt-1 mt-1 mb-1"
}
const _hoisted_4 = { class: "content-end" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex items-center ml-6 py-1.5" }
const _hoisted_7 = { class: "w-full h-min sm:h-48 sm:h-min" }
const _hoisted_8 = { class: "flex relative" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "overflow-hidden flex w-full h-auto lg:flex-nowrap flex-wrap" }
const _hoisted_11 = { class: "w-full mx-auto pt-2" }
const _hoisted_12 = { class: "content-end" }

import { ref, Ref, onMounted } from 'vue';
// import { usePlayApiStore } from "../store/api/playApi";
// import { useRealtimeApiStore } from "../store/api/realtimeApi";
import { TempData } from '@/models/queryBuilder'
import { GenderEnum, CountryEnum, BowlingStyleEnum, BattingHandEnum, PlayingRoleEnum } from '@/models/vscoreModels'

import { useConfirm } from "primevue/useconfirm";
import Button from 'primevue/button'
import ProgressSpinner from 'primevue/progressspinner'
import Details from '../components/InformationCard.vue'
import EditInfo from '../components/EditInformationCard.vue';
import Table from '../components/DataTable.vue';
import DataTabs from '../components/DataTabs.vue';

// const playApi = usePlayApiStore()
// const api = useRealtimeApiStore()


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerManager',
  props: ['selectedPlayer', 'limit'],
  emits: ['return', 'save', 'changeEditStatus', 'setTableSize'],
  setup(__props, { emit: __emit }) {

const confirm = useConfirm();
const props = __props
const emit = __emit

const state = ref({
    isLoading: true,
    isEditMode: false,
    isNewPlayer: (Object.keys(props.selectedPlayer).length == 0),
    hasWarning: false,
})

const playerColumns = [
    [
        { name: 'Batter', key: 'batter' },
        { name: 'Team', key: 'team' },
        { name: 'Bowler', key: 'bowler' },
        { name: 'Field Team', key: 'field_team' },
        { name: 'Bowl Type', key: 'bowl_type' },
        { name: 'Event Type', key: 'event_type' },
        { name: 'Game', key: 'game' },
    ],
    [
        { name: 'Name', key: 'name' },
        { name: 'Country', key: 'country' },
        { name: 'Coach', key: 'coach' },
        { name: 'Players', key: 'players' },
        { name: 'Season', key: 'season' },
        { name: 'Updated', key: 'updated' }
    ]
]

const displayColumns = [
    // { name: 'ID', key: 'id' },
    { name: 'First Name', key: 'firstName' },
    { name: 'Last Name', key: 'lastName' },
    { name: 'Middle Names', key: 'middleNames' },
    { name: 'Nick Names', key: 'nickNames' },
    { name: 'Date Of Birth', key: 'dateOfBirth' },
    { name: 'Gender', key: 'gender' },
    { name: 'Batting Hand', key: 'battingHand' },
    { name: 'Playing Role', key: 'playingRole' },
    { name: 'Bowling Style', key: 'bowlingStyle' },
    { name: 'Country', key: 'country' },
]

const tabHeaders = ["Plays", "Career"]

const playData: TempData[] = []
const careerData: TempData[] = []

const data = ref([playData, careerData])

const emptyInfo = {
    data: {
        "First Name": { value: "", type: "text", required: true },
        "Last Name": { value: "", type: "text", required: true },
        "Nick Names": { value: "", type: "text", required: false },
        "Date Of Birth": { value: "", type: "calendar", required: false },
        "Gender": {
            value: "",
            type: "dropdown",
            options: Object.values(GenderEnum).filter((item) => { return isNaN(Number(item)) }),
            required: true
        },
        "Country": {
            value: "",
            type: "autoComplete",
            options: Object.values(CountryEnum).filter((item) => { return isNaN(Number(item)) }), 
            required: false
        },
        "Bowling Style": {
            value: "",
            type: "dropdown",
            options: Object.values(BowlingStyleEnum).filter((item) => { return isNaN(Number(item)) }), 
            required: false
        },
        "Playing Role": {
            value: "",
            type: "dropdown",
            options: Object.values(PlayingRoleEnum).filter((item) => { return isNaN(Number(item)) }), 
            required: false
        },
        "Batting Hand": {
            value: "",
            type: "dropdown",
            options: Object.values(BattingHandEnum).filter((item) => { return isNaN(Number(item)) }), 
            required: true
        },
        "Middle Names": { value: "", type: "text", required: false },
    },
}
let information = ref(JSON.parse(JSON.stringify(emptyInfo)))

const tableOffset = ref(0)
const editableInformation = ref(getInfo())
const tableData = ref()

onMounted(async () => {
    state.value.isLoading = true
    information.value["image"] = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 512 512'%3E%3Cpath fill='%23243045' d='M256 256a112 112 0 1 0-112-112a112 112 0 0 0 112 112m0 32c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128'/%3E%3C/svg%3E"

    if (!state.value.isNewPlayer) {
        // TODO
        getPlayerData()

        displayColumns.forEach((element) => {
            information.value.data[element.name].value = props.selectedPlayer[element.key]
        });
        // information.value.data["Date Of Birth"].value = "1998-02-02"
        // information.value["image"] = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 512 512'%3E%3Cpath fill='%23243045' d='M256 256a112 112 0 1 0-112-112a112 112 0 0 0 112 112m0 32c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128'/%3E%3C/svg%3E"
        tableData.value = unWrapData()
        editableInformation.value = getInfo()
        emit('setTableSize')
    } else {
        resetData()
        state.value.isEditMode = true
    }

    state.value.isLoading = false
})


/**
 * Remove reactivity from referenced object to ensure unedited state is perserved
 * @returns new copy of data object prop
 */
function unWrapData() {
    let tempArray: any[] = []
    data.value.forEach((element: TempData[]) => {
        tempArray.push(JSON.parse(JSON.stringify(element)))
    });
    return tempArray
}

/**
 * Remove reactivity from referenced object to ensure unedited state is perserved
 * @returns new copy of imformation.data
 */
function getInfo() {
    return JSON.parse(JSON.stringify(information.value.data))
}

const confirmSave = () => {
    validate()
    if (!state.value.hasWarning) {
        confirm.require({
            message: 'Confirm to save',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            rejectLabel: 'Cancel',
            acceptLabel: 'Save',
            accept: () => {
                //save entry
                save()
                emit('changeEditStatus', false)
                state.value.isEditMode = false
                state.value.isNewPlayer = false
            }
        });
    }
};

const confirmCancel = () => {
    confirm.require({
        message: 'Are you sure you want to leave? Your changes will be lost',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {
            state.value.hasWarning = false
            emit('changeEditStatus', false)
            state.value.isEditMode = false
            resetData()
            if (state.value.isNewPlayer) {
                emit('return')
            }
        }
    });
};

function validate() {
    state.value.hasWarning = false
    if (editableInformation.value["First Name"].value == "") {
        state.value.hasWarning = true
    } 
    if (editableInformation.value["Last Name"].value == "") {
        state.value.hasWarning = true
    }
    if (editableInformation.value["Gender"].value == "") {
        state.value.hasWarning = true
    }
    if (editableInformation.value["Batting Hand"].value == "") {
        state.value.hasWarning = true
    }
}

async function save() {

    // Annoying date format manipulation
    const date = new Date(editableInformation.value["Date Of Birth"].value).toLocaleDateString().split("/")
    editableInformation.value["Date Of Birth"].value = date[2] + "-" + date[1] + "-" + date[0];

    data.value = JSON.parse(JSON.stringify(tableData.value))
    information.value.data = JSON.parse(JSON.stringify(editableInformation.value))
    // TODO - save

    if (state.value.isNewPlayer) {
        const newPlayer: any = {
            name: editableInformation.value["First Name"].value + " " + editableInformation.value["Last Name"].value,
            firstName: editableInformation.value["First Name"].value,
            lastName: editableInformation.value["Last Name"].value,
            gender: editableInformation.value["Gender"].value,
            battingHand: editableInformation.value["Batting Hand"].value,

            // lastName: editableInformation.value["Name"].value.split
            // firstName: editableInformation.value["Name"].value.split
        }
        if (editableInformation.value["Nick Names"].value !== "")
            newPlayer["nickNames"] = editableInformation.value["Nick Names"].value.split(" ")

        // TODO - inspect format of date
        if (editableInformation.value["Date Of Birth"].value !== "")
            newPlayer["dateOfBirth"] = editableInformation.value["Date Of Birth"].value
        if (editableInformation.value["Bowling Style"].value !== "")
            newPlayer["bowlingStyle"] = editableInformation.value["Bowling Style"].value
        if (editableInformation.value["Country"].value !== "")
            newPlayer["country"] = editableInformation.value["Country"].value
        if (editableInformation.value["Playing Role"].value !== "")
            newPlayer["playingRole"] = editableInformation.value["Playing Role"].value
        if (editableInformation.value["Middle Names"].value !== "")
            newPlayer["middleNames"] = editableInformation.value["Middle Names"].value.split(" ")
        // API CALL
        // await api.createPlayer(newPlayer).then((response) => {
        //     state.value.isNewPlayer = false
        //     console.log("location: " + response)
        // })
    }


}

function resetData() {
    editableInformation.value = getInfo()
    tableData.value = unWrapData()
}

/**
 * Remove item from table
 * Item is only removed from entity when changes are saved
 * @param item to be removed from table
 */
function removeItem(item: any) {
    tableData.value.forEach(function (elementArray: [], indexArray: number) {
        elementArray.forEach(function (element: object, index: number) {
            if (element === item) {
                tableData.value[indexArray].splice(index, 1)
            }
        })
    });
}

function getPlayerData() {
    data.value[0] = [
        {
            batter: "Ariana",
            team: "NZ",
            bowler: "Sheehan E",
            field_team: "AUS",
            bowl_type: "Spin Pace Curve",
            event_type: "Wicket",
            game: "2023-09-02",
        },
        {
            batter: "Ariana",
            team: "NZ",
            bowler: "Sheehan E",
            field_team: "AUS",
            bowl_type: "Seamer",
            event_type: "Wicket",
            game: "2023-09-02",
        }
    ]

    data.value[1] = [
        {
            name: "Black Caps",
            country: "New Zealand",
            coach: "Gary Stead",
            players: "22",
            season: "ALL",
            updated: "1 Month Ago",
        },
        {
            name: "White Ferns",
            country: "New Zealand",
            coach: "Ben Sawyer",
            players: "22",
            season: "ALL",
            updated: "1 Month Ago",
        },
    ]
}


return (_ctx: any,_cache: any) => {
  return (!state.value.isEditMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          icon: "pi pi-chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('return'); resetData();}),
          class: "absolute left-0 top-0 mt-1 pl-0 pr-4 w-max",
          "aria-label": "Bookmark"
        }),
        _createVNode(Details, {
          information: _unref(information),
          class: "py-2 pl-4 information"
        }, null, 8, ["information"]),
        _createVNode(DataTabs, {
          headers: tabHeaders,
          expandedActive: 0,
          parentTabActive: 2,
          class: "mb-3 relative"
        }, {
          default: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_2, [
              (!state.value.isLoading)
                ? (_openBlock(), _createBlock(Table, {
                    key: 0,
                    "is-edit-mode": false,
                    data: data.value[slotProps.index].slice(tableOffset.value, tableOffset.value + __props.limit),
                    columns: playerColumns[slotProps.index],
                    onNextPage: _cache[1] || (_cache[1] = ($event: any) => (tableOffset.value = tableOffset.value + __props.limit)),
                    onPrevPage: _cache[2] || (_cache[2] = ($event: any) => (tableOffset.value = tableOffset.value - __props.limit)),
                    limit: __props.limit,
                    offset: tableOffset.value,
                    "total-count": data.value[slotProps.index].length,
                    message: { title: 'No Entries', paragraph: 'No current data for this player' }
                  }, null, 8, ["data", "columns", "limit", "offset", "total-count"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_unref(ProgressSpinner), {
                      class: "justify-center w-90 h-90",
                      "attrs-color-black": "",
                      strokeWidth: "5",
                      animationDuration: "1s",
                      "aria-label": "Loading"
                    })
                  ]))
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          (!state.value.isEditMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = ($event: any) => {state.value.isEditMode = true; _ctx.$emit('changeEditStatus', true)}),
                class: "bg-[#1f2937] hover:bg-slate-500 text-white ml-2 mb-2 mt-0 font-semi h-6 py-0 pb-0.5 rounded w-24 float-right flex items-center justify-center"
              }, " Edit "))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_unref(information).image !== undefined)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(information).image,
                    alt: "Image",
                    class: "w-auto h-20 sm:w-auto sm:h-48 self-center mr-8"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(EditInfo, {
                  information: editableInformation.value,
                  warning: state.value.hasWarning,
                  class: "overflow-x-auto"
                }, null, 8, ["information", "warning"])
              ])
            ])
          ])
        ]),
        _createVNode(DataTabs, {
          headers: tabHeaders,
          class: "mb-3 relative pt-1",
          expandedActive: 0,
          parentTabActive: 2
        }, {
          default: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(Table, {
                "is-edit-mode": true,
                data: tableData.value[slotProps.index].length !== 0 ? tableData.value[slotProps.index].slice(tableOffset.value, tableOffset.value + __props.limit) : tableData.value[slotProps.index],
                columns: playerColumns[slotProps.index],
                onNextPage: _cache[4] || (_cache[4] = ($event: any) => {tableOffset.value = tableOffset.value + __props.limit;}),
                onRemoveItem: removeItem,
                onPrevPage: _cache[5] || (_cache[5] = ($event: any) => (tableOffset.value = tableOffset.value - __props.limit)),
                limit: __props.limit,
                offset: tableOffset.value,
                "total-count": tableData.value[slotProps.index].length,
                message: { title: 'No Entries', paragraph: 'No current data for this player' }
              }, null, 8, ["data", "columns", "limit", "offset", "total-count"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => {confirmSave();}),
            class: "bg-[#1f2937] hover:bg-slate-500 text-white ml-2 mb-2 mt-0 font-semi h-6 py-0 pb-0.5 rounded w-24 float-right flex items-center justify-center"
          }, " Save "),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => {confirmCancel();}),
            class: "border-[#1f2937] border-2 hover:bg-gray-200 text-[#1f2937] ml-2 mb-2 mt-0 font-semi h-6 py-0 pb-0.5 justify-center rounded w-24 float-right flex items-center"
          }, " Cancel ")
        ])
      ]))
}
}

})